import TagIconCancel from "./TagIconCancel";

export default TagIconCancel;
